// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"b22ada7c","300":"3c4d0e22","303":"ccacf536","453":"0a683351","683":"5280641b"}[chunkId] + ".chunk.js";
};